<template>
  <v-app :class="`${getForAccessibility ? 'for-accessibility-app' : ''}`" v-if="userAuth">
    <template v-if="userAgreement && userSavAgreement">
      <el-overlay-loading :loading="!loadedSavitarna" />
      <sav-toolbar class="app--toolbar" @loaded="loadedToolbar = true" />
      <v-main class="savitarna-main">
        <div class="savitarna-content-wrapper">
          <v-sheet class="d-flex">
            <div class="savitarna-content-left">
              <sav-left-menu @loaded="loadedMenu = true" />
            </div>
            <div class="savitarna-content-info" v-if="loadedSavitarna">
              <sav-breadcrumbs class="ma-0 pa-0" />
              <el-system-info />
              <router-view class="pa-0 mb-1" />
            </div>
          </v-sheet>
        </div>
        <sav-footer />
      </v-main>
      <app-fab />
    </template>
    <modal-sav-agreement
      v-model="showAgreementSavModal"
      :loading="loading"
      @cancelAgreement="cancelAgreement"
    />
    <modal-ireg-agreement
      v-model="showAgreementModal"
      :loading="loading"
      @confirmAgreement="confirmAgreement"
      @cancelAgreement="cancelAgreement"
    />
  </v-app>
  <div v-else-if="showVerificationInRegisterMsg">
    <el-overlay-loading
      :subText="verificationSubMsg"
      :text="verificationMsg"
      :loading="true"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import checkUser from '@/mixins/checkUser'
import SavToolbar from './savitarna/SavToolbar'
import SavLeftMenu from './savitarna/SavLeftMenu'
import SavBreadcrumbs from './savitarna/SavBreadcrumbs'
import SavFooter from './savitarna/SavFooter'
import AppFab from './ireg/AppFab'
import ModalSavAgreement from '@/components/modals/ModalSavAgreement'
import ModalIregAgreement from '@/components/modals/ModalIregAgreement'
export default {
  name: 'LayoutSavitarna',
  components: {
    SavToolbar,
    SavLeftMenu,
    SavBreadcrumbs,
    SavFooter,
    AppFab,
    ModalSavAgreement,
    ModalIregAgreement,
  },
  mixins: [checkUser],
  data() {
    return {
      userAuth: false,
      loadedToolbar: false,
      loadedMenu: false,
      loading: false,
    }
  },
  computed: {
    ...mapGetters([
      'userID',
      'savitarnaHomeUrl',
      'userAgreement',
      'userSavAgreement',
      'getDataVerificationInRegister',
      'getForAccessibility',
    ]),
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    isDevelop() {
      return process.env.VUE_APP_LOCAL === 'develop'
    },
    loadedSavitarna() {
      return this.loadedToolbar && this.loadedMenu
    },
    showVerificationInRegisterMsg() {
      return !this.getDataVerificationInRegister
    },
    verificationMsg() {
      return this.$t('Prašome palaukti.')
    },
    verificationSubMsg() {
      return this.$t(
        'Vyksta Jūsų duomenų tikrinimas Neveiksnių ir ribotai veiksnių asmenų registre.'
      )
    },
    showAgreementSavModal: {
      set(value) {
        //
      },
      get() {
        return !this.userSavAgreement && this.userAgreement
      },
    },

    showAgreementModal: {
      set(value) {
        //
      },
      get() {
        return !this.userAgreement
      },
    },
  },
  watch: {
    isAppIdle(val) {
      if (val) {
        if (!this.isLocal) {
          this.$store.dispatch('unlockObj')
          this.$root.$emit('SAV_SESSION_ERROR')
        }
      }
    },
  },
  created() {
    this.getParams()
    this.checkSavitarna()
    if(this.getForAccessibility){
      document.documentElement.style.setProperty('--scrollbar-color', 'gray');
      document.documentElement.style.setProperty('--scrollbar-hover-color', 'gray');
    }
  },
  mounted() {
    let savitarnaFunc = document.createElement('script')
    savitarnaFunc.setAttribute('src', 'https://w2dev.kada.lt/savitarna/javascripts/func.js')
    document.head.appendChild(savitarnaFunc)
  },
  methods: {
    getParams() {
      let params = this.$route.query
      if (params.lang) {
        this.$store.dispatch('changeLanguage', {
          lang: params.lang,
          i18n: this.$i18n,
        })
      }
      if(this.$route.query.accessibility){
        this.$store.dispatch('changeForAccessibility', this.$route.query.accessibility == '1')
      }
    },
    checkSavitarna() {
      if (this.isLocal) {
        this.checkUser()
        return
      }
      this.checkUserSavitarna()
    },
    confirmAgreement(ids) {
      this.loading = true
      let data = {
        user_id: this.userID,
        read_understood: true,
        ids: ids,
      }
      this.$axios
        .post(`security-notifications-agreements`, data)
        .then((res) => {
          this.$store.dispatch('userAgreement', true)
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    cancelAgreement() {
      let link = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}goto.do?menuId=1`
      window.location.href = link
    },
  },
}
</script>

<style lang="scss" scoped>
.app-root {
  background: #fff;
}
.savitarna-content-wrapper {
  width: 1000px !important;
  margin-left: auto !important;
  margin-right: auto !important;
  padding: 0 10px 0 10px !important;
}
.savitarna-content-left {
  width: 220px;
  padding: 0;
}
.savitarna-content-info {
  min-height: calc(100vh - 120px - 200px);
  width: calc(1000px - 220px);
  margin-left: 32px;
  padding: 0;
  background: none;
}
</style>
